"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const brand_1 = require("services/master-data/brand");
const brand_types_1 = require("./brand.types");
const getDataGrid = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, brand_1._getBrandData)(dataStates);
    if (response.isError) {
        const payload = {
            isError: response.isError,
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
        };
        dispatch({ type: brand_types_1.brandTypes.SET_ERROR, payload: payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: brand_types_1.brandTypes.SET_DATA_GRID, payload: payload });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = { dataStates };
    dispatch({ type: brand_types_1.brandTypes.ON_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: brand_types_1.brandTypes.ON_MUTATION_CLICK, payload });
};
const onSaveDataItem = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { mutationMode, dataItem } = payload;
    const response = mutationMode === 'add'
        ? yield (0, brand_1._postBrandData)({
            code: dataItem.code,
            name: dataItem.name,
            color: dataItem.color,
            is_active: dataItem.is_active
        })
        : yield (0, brand_1._putBrandData)({
            id: dataItem.id,
            code: dataItem.code,
            name: dataItem.name,
            color: dataItem.color,
            is_active: dataItem.is_active
        });
    if (response.isError) {
        dispatch({
            type: brand_types_1.brandTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: response.errorMessage,
            }
        });
    }
    else {
        dispatch({
            type: brand_types_1.brandTypes.ON_SAVE_DATAITEM,
            payload: {
                mutationMode,
                dataItem,
                isSuccess: !response.isError
            }
        });
    }
});
const onDeleteDataItem = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { mutationMode, dataItem } = payload;
    const response = yield (0, brand_1._deleteBrandData)({ id: dataItem.id });
    if (response.isError) {
        dispatch({
            type: brand_types_1.brandTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: response.errorMessage,
            }
        });
    }
    else {
        dispatch({
            type: brand_types_1.brandTypes.ON_DELETE_DATAITEM,
            payload: {
                dataItem,
                mutationMode,
                isSuccess: !response.isError
            }
        });
    }
});
const onFilterChange = payload => dispatch => {
    dispatch({ type: brand_types_1.brandTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: brand_types_1.brandTypes.ON_SORT_CHANGE, payload });
};
const onCloseError = () => dispatch => {
    dispatch({
        type: brand_types_1.brandTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false
        }
    });
};
const onLoading = () => dispatch => {
    dispatch({ type: brand_types_1.brandTypes.SET_LOADING, payload: true });
};
const onGetDataEnumBrandColor = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, brand_1._getEnumBrandColor)();
    if (response.isError) {
        dispatch({
            type: brand_types_1.brandTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: 'Error Fetching Enum Dumping Data. \n'.concat(response.errorMessage),
            }
        });
    }
    else {
        dispatch({ type: brand_types_1.brandTypes.SET_DATA_ENUM, payload: response.data });
    }
});
exports.default = {
    getDataGrid,
    onSaveDataItem,
    onClickMutation,
    onDeleteDataItem,
    onDataStateChange,
    onFilterChange,
    onSortChange,
    onCloseError,
    onLoading,
    onGetDataEnumBrandColor
};
